export const MOBILE_BREAKPOINT_PX = 600;
export const MOBILE_MEDIA_QUERY = `(max-width:${MOBILE_BREAKPOINT_PX}px)`;
